import { FormControl, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

function UtilityCompanySelector({ utilityCompanyId, utilityCompanies, handleUtilityCompanyChange }) {
  // Find the selected company object based on utilityCompanyId
  const selectedCompany = utilityCompanies.find((company) => company.id === utilityCompanyId) || null;

  return (
    <FormControl style={{ width: 200 }}>
      <Autocomplete
        options={utilityCompanies}
        getOptionLabel={(option) => option.name || ""}
        getOptionSelected={(option, value) => option.id === value.id}
        value={selectedCompany}
        onChange={(event, newValue) => {
          // Call handleUtilityCompanyChange with the new id (or null if cleared)
          handleUtilityCompanyChange({
            target: { value: newValue ? newValue.id : "" },
          });
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Utility Company"
            placeholder="Select Utility Company"
            variant="standard"
          />
        )}
      />
    </FormControl>
  );
}

export default UtilityCompanySelector;